import React, { useState, useEffect } from "react";
import { useTheme } from 'styled-components';
import { Box, Pool, PoolLoading, Wrapper } from "./style";
import { Col, Row } from "react-bootstrap";
import CardHeader from "../CardHeader";
import CardMiddle from "../CardMiddle";
import PoolDetails from "../PoolDetail";
import Stake from "../../Stake";
import Unstake from "../../Unstake";
import { useSelector, useDispatch } from "react-redux";
import { useRouteMatch } from "react-router";
import useRefresh from '../../../hooks/useRefresh';
import {
  setRewardDecimalLocally,
  dynamicTheme,
  Allowance,
  Symbols,
  getWeb3ForChainId,
  poolDetailFromNetwork,
  getActionBasedData,
  getFirstLoadData,
  getSecondLoadData
} from "../../../common/BPADBlockStakeContract";
import {
  setActionBasedData,
  setCorePool,
  setCorePoolAddress,
  setFirstLoadData,
  setNetworkIdFromUrl,
  setPoolAddresses,
  setPoolContracts,
  setPoolDetailsFromFactory,
  setRewardDecimalPoolTokenDecimal,
  setSecondLoadData,
  setTknSymbol,
} from "../../../store/actions/globalActions";
import { corepoolabi } from "../../../common/helpers/corepoolabi";
import { poolfactoryAbi } from "../../../common/helpers/poolfactory";
import { poolRewardABI } from "../../../common/helpers/poolRewardABI";
import { poolTokenAbi } from "../../../common/helpers/poolTokenAbi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getAxiosInst, { apiHandler } from "../../../services/apiService/axios";
import { setProjectNamePoolName, setApproved } from "../../../store/actions/globalActions";
import "./style.css"
import { getChainDataByChainId } from "../../../utils";
import Loader from "react-loader-spinner";
import HashLoader from "react-spinners/HashLoader";
import { data } from "./contant"


function PoolCard(props) {
  const [stakeVisibility, SetStakeVisibility] = useState(false);
  const [UnstakeVisibility, SetUnStakeVisibility] = useState(false);
  const { params } = useRouteMatch();
  const [networkIdFromBackend, setNetworkIdFromBackend] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();

  const dispatch = useDispatch();
  const { fastRefresh } = useRefresh();

  const { poolTokenContract, rewardContract } =
    useSelector((state) => state.global.poolContracts);
  const { isApproved, currentChainId } =
    useSelector((state) => state.global);

  const hideStake = () => {
    SetStakeVisibility(false);
  };

  const showStake = () => {
    SetStakeVisibility(true);
  };

  const hideUnStake = () => {
    SetUnStakeVisibility(false);
  };

  const showUnStake = () => {
    SetUnStakeVisibility(true);
  };

  function success(Message) {
    toast(Message);
  }

  // const corePoolAddress = params?.corePoolAddress;
  // const networkIdFromUrl = params?.network;

  const corePoolAddress = "0x510a427581EFB83FBa0B112B75bC755C67c7209C";
  const networkIdFromUrl = "bsc";

  useEffect(async () => {
    if (isApproved !== 2 && corePoolAddress && poolTokenContract) {
      const allowance = await Allowance(corePoolAddress, poolTokenContract);
      if (allowance === "0") {
        dispatch(setApproved(1));
      } else dispatch(setApproved(2));
    }
  }, [fastRefresh, isApproved, poolTokenContract])

  // useEffect(async () => {
  //   const { rewardTknSymbol, poolTknSymbol } = await Symbols(rewardContract, poolTokenContract);
  //   dispatch(setTknSymbol(rewardTknSymbol, poolTknSymbol))
  // }, [poolTokenContract])

  const setTokenSymbol = async (rewardContract, poolTokenContract) => {
    const { rewardTknSymbol, poolTknSymbol } = await Symbols(rewardContract, poolTokenContract);
    dispatch(setTknSymbol(rewardTknSymbol, poolTknSymbol))
  }

  const setTokenDecimal = async (rewardContract, poolTokenContract) => {
    const rewardDecimal = await rewardContract?.methods?.decimals()?.call();
    const poolTokenDecimal = await poolTokenContract?.methods
      ?.decimals()
      ?.call();
    setRewardDecimalLocally(rewardDecimal, poolTokenDecimal);
    dispatch(
      setRewardDecimalPoolTokenDecimal(rewardDecimal, poolTokenDecimal)
    );
    return {
      rewardDecimal,
      poolTokenDecimal
    }
  }

  const setPoolDetails = async (corePoolContract, poolFactoryContract, poolTokenAddress) => {
    let data = await poolDetailFromNetwork(corePoolContract, poolFactoryContract, poolTokenAddress)
    dispatch(
      setPoolDetailsFromFactory(
        data.startBlock,
        data.currentBlockNO,
        data.endBlock,
        data.rewardTokenPerBlock
      )
    )
    return data
  }

  const fetchAndSetFirstLoadData = async (
    corePoolContract,
    corePoolAddress,
    poolFactoryContract,
    poolTokenContract,
    chainId,
    rewardPerBlock
  ) => {
    let data = await getFirstLoadData(
      corePoolContract,
      corePoolAddress,
      poolFactoryContract,
      poolTokenContract,
      chainId,
      rewardPerBlock
    )
    dispatch(
      setFirstLoadData(
        data.Apy,
        data.balanceOfTvl,
        data.totalStakevalue,
        data.totalStake,
        data.reward,
      )
    )
  }

  const fetchAndSetSecondLoadData = async (
    corePoolContract,
    poolFactoryContract,
    poolFactoryAddress,
    rewardContract,
    poolTokenContract,
  ) => {
    let data = await getSecondLoadData(
      corePoolContract,
      poolFactoryContract,
      poolFactoryAddress,
      rewardContract,
      poolTokenContract
    )
    dispatch(
      setSecondLoadData(
        data.tokenBalance,
        data.EligibleunStake,
        data.RewardDiff,
        data.rewardDistributed,
        data.rewardBalanceOf,
      )
    )
  }

  const setContractsandAddresses = async (
    corePoolAddress,
    networkIdFromURL
  ) => {
    const address = corePoolAddress;
    if (address) {
      try {
        let chainData = getChainDataByChainId(networkIdFromBackend)
        if (chainData.urlChainName === networkIdFromURL) {
          dispatch(setNetworkIdFromUrl(networkIdFromBackend))
        } else {
          throw new Error("Wrong URL");
        }
        let Web3Obj = await getWeb3ForChainId(chainData.chainId)

        const corePoolContract = new Web3Obj.eth.Contract(corepoolabi, address);

        const poolFactoryAddress = await corePoolContract?.methods
          ?.factory()
          ?.call();
        const poolFactoryContract = new Web3Obj.eth.Contract(
          poolfactoryAbi,
          poolFactoryAddress
        );

        const rewardAddress = await corePoolContract?.methods
          ?.rewardToken()
          ?.call();
        const rewardContract = new Web3Obj.eth.Contract(
          poolRewardABI,
          rewardAddress
        );

        const poolTokenAddress = await corePoolContract?.methods
          ?.poolToken()
          ?.call();
        const poolTokenContract = new Web3Obj.eth.Contract(
          poolTokenAbi,
          poolTokenAddress
        );

        await setTokenDecimal(rewardContract, poolTokenContract)
        await setTokenSymbol(rewardContract, poolTokenContract)
        let { rewardTokenPerBlock } = await setPoolDetails(corePoolContract, poolFactoryContract, poolTokenAddress)
        await Promise.all([
          fetchAndSetFirstLoadData(corePoolContract,
            corePoolAddress,
            poolFactoryContract,
            poolTokenContract,
            networkIdFromBackend,
            rewardTokenPerBlock),
          fetchAndSetSecondLoadData(corePoolContract,
            poolFactoryContract,
            poolFactoryAddress,
            rewardContract,
            poolTokenContract)
        ])


        dispatch(setCorePool(corePoolContract));
        dispatch(setCorePoolAddress(address));
        dispatch(
          setPoolAddresses(poolFactoryAddress, rewardAddress, poolTokenAddress)
        );
        dispatch(
          setPoolContracts(
            poolFactoryContract,
            rewardContract,
            poolTokenContract
          )
        );
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        success(error.message);
      }
    }
  };

  useEffect(() => {
    console.log(data.data)
    setNetworkIdFromBackend(parseInt(data?.data.chain_id));
    dynamicTheme(data?.data.pool_theme);
    dispatch(setProjectNamePoolName(data.data));

    // apiHandler(
    //   () =>
    //     getAxiosInst({ withAuth: true, baseURL: "pool" }).get(
    //       `/getpoolbypooladdress?pool_address=${corePoolAddress}`
    //     ),
    //   {
    //     onSuccess: (response) => {
    //       if (response && response?.data) {
    //         setNetworkIdFromBackend(parseInt(response?.data?.chain_id));
    //         dynamicTheme(response?.data?.pool_theme);
    //         dispatch(setProjectNamePoolName(response?.data));
    //       } else {
    //         setIsLoading(false);
    //         success("Incorrect URL");
    //       }
    //     },
    //     onError: (error) => {
    //       setIsLoading(false);
    //       success("Can't get network id from backend");
    //       console.log("InError");
    //       console.log("error", error);
    //     },
    //   }
    // );
  }, [corePoolAddress]);

  useEffect(() => {
    if (!isNaN(networkIdFromBackend)) {
      setContractsandAddresses(corePoolAddress, networkIdFromUrl);
    }
  }, [corePoolAddress, networkIdFromUrl, networkIdFromBackend]);

  return (
    <Wrapper>
      <Pool>
        <Row>
          <Col xs={12} md={7}>
            <Box>
              <CardHeader />
              <CardMiddle onStake={showStake} onUnstake={showUnStake} />
            </Box>
          </Col>
          <Col className="col-left-padding" xs={12} md={5}>
            <PoolDetails />
          </Col>
        </Row>
        <Stake show={stakeVisibility} onHide={hideStake} />
        <Unstake show={UnstakeVisibility} onHide={hideUnStake} />
      </Pool>
      {isLoading && (<PoolLoading>
        {/* <Loader type="CradleLoader" heigth="100" width="100" arialLabel="loading-indicator" /> */}
        {/* <PacmanLoader></> */}
        <HashLoader loading={isLoading} color={theme.palette.card.text.primary} size={50} />
      </PoolLoading>)}
    </Wrapper>
  );
}

export default PoolCard;
